<template>
  <Header_AS @on-change-main-page="getMainPageData()" />

  <!-- Young Talent Banner -->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div
          class="img-banner-home-header"
          :style="{ backgroundImage: `url(${fondoPYT})` }"
        ></div>
      </div>

      <div class="sobrefondo"></div>

      <div class="container px-5 container-banner-img">
        <div class="stack-badges">
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-secundario d-none d-md-block"
          />
          <img
            v-if="!isMobile"
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge d-none d-md-block"
          />
        </div>
      </div>

      <div class="container px-5 banner-text-wrapper">
        <div v-if="isMobile" class="stack-badges-mobile">
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-02.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-03.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
          <img
            src="@/assets/talento_agv/img/home/Sellos GPTW-01.webp"
            alt="Certificado"
            class="certificado-badge-mobile"
          />
        </div>
        <div class="banner-text-inner">
          <div :class="['text-start', { aos: !isMobile }]" :data-aos="!isMobile ? 'fade-up' : null">
            <h2 class="banner-title">
              {{ tituloUno }}
              <span class="banner-title-culture">{{ tituloDos }}</span>
              {{ tituloTres }}
            </h2>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- HEADER azul marino con título -->
  <section class="section-header-our-young-talent">
    <div class="container px-5">
      <div class="aos" data-aos="fade-up">
        <div class="text-center">
          <h3
            class="section-header-our-young-talent-header-title text-white py-3 d-flex justify-content-center align-items-center m-0"
          >
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
            <span>{{ $t('¡Conoce a nuestros Young Talent!') }}</span>
            <img src="@/assets/talento_agv/img/arrow.png" class="arrow-icon" />
          </h3>
        </div>
      </div>
    </div>
  </section>

  <!-- Carrusel Young Talent -->
  <section class="section-content-our-young-talent py-4 py-md-5">
    <div class="container px-5">
      <div class="container-carousel-our-young-talent">
        
        <!-- ==========================================
             MOBILE CAROUSEL (1 item per slide)
             Dots = number of items
        ========================================== -->
        <Carousel
          v-if="isMobile"
          :autoplay="3000"
          :wrap-around="true"
          :items-to-show="1"
          :items-to-scroll="1"
        >
          <Slide
            v-for="item in youngTalentRaw"
            :key="item.id"
          >
            <div class="slide-content-wrapper">
              <div class="grid-item">
                <!-- imagen -->
                <img
                  :src="item.img"
                  class="carousel-card-img"
                  alt="Young Talent"
                />

                <!-- overlay oscuro gradiente -->
                <div class="grid-item-overlay"></div>

                <!-- texto y play -->
                <div class="grid-item-caption">
                  <div class="grid-item-text">
                    <p class="grid-item-name">{{ item.name }}</p>
                    <p class="grid-item-age">{{ item.age }} años</p>
                  </div>

                  <button
                    type="button"
                    class="grid-item-play"
                    @click="openVideoTalent(item)"
                  >
                    <i class="bx bx-play"></i>
                  </button>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination class="custom-dots" />
          </template>
        </Carousel>

        <!-- ==========================================
             DESKTOP CAROUSEL (Groups of 3)
             Dots = number of groups
        ========================================== -->
        <Carousel
          v-else
          :autoplay="3000"
          :wrap-around="true"
          :items-to-show="1"
          :items-to-scroll="1"
        >
          <Slide
            v-for="(slide, idx) in youngTalentSlides"
            :key="`slide-${idx}`"
          >
            <div class="grid-container px-3">
              <div
                v-for="item in slide.items"
                :key="item.id"
                class="grid-item"
              >
                <!-- imagen -->
                <img
                  :src="item.img"
                  class="carousel-card-img"
                  alt="Young Talent"
                />

                <!-- overlay oscuro gradiente -->
                <div class="grid-item-overlay"></div>

                <!-- texto y play -->
                <div class="grid-item-caption">
                  <div class="grid-item-text">
                    <p class="grid-item-name">{{ item.name }}</p>
                    <p class="grid-item-age">{{ item.age }} años</p>
                  </div>

                  <button
                    type="button"
                    class="grid-item-play"
                    @click="openVideoTalent(item)"
                  >
                    <i class="bx bx-play"></i>
                  </button>
                </div>
              </div>
            </div>
          </Slide>

          <template #addons>
            <Pagination class="custom-dots" />
          </template>
        </Carousel>

      </div>
    </div>
  </section>


  <div class="section-footer-our-young-talent"></div>

  <!-- Footer -->
  <Footer_AS />

  <!-- Button work -->
  <Button_work_AS />

  <!-- Modal de video -->
  <v-dialog 
    v-model="dialog" 
    :width="dialogWidth"
    scrim="black"
    :scrim-opacity="0.85"
  >
    <v-card :class="['modal-transparent', { 'modal-fullscreen': isMobile }]">
      <!-- BOTÓN CERRAR -->
      <button
        class="close-btn"
        @click="closeModal"
        aria-label="Cerrar video"
        title="Cerrar"
      >
        ✕
      </button>

      <template #text>
        <div class="modal-video-wrapper">
          <iframe
            ref="modalVideo"
            :src="urlVideoEmbed"
            class="modal-video"
            frameborder="0"
            allow="autoplay; picture-in-picture; clipboard-write;"
            allowfullscreen
            :style="modalVideoStyle"
          ></iframe>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import axiosIns from "@/plugins/axios.js";
import AOS from "aos";
import "vue3-carousel/dist/carousel.css";
import { Carousel, Slide, Pagination } from "vue3-carousel";

import Button_work_AS from "./components/Button_work_AS.vue";
import Footer_AS from "./components/Footer_AS.vue";
import Header_AS from "./components/Header_AS.vue";

export default {
  components: {
    Button_work_AS,
    Carousel,
    Footer_AS,
    Header_AS,
    Pagination,
    Slide,
  },
  data() {
    return {
      dialog: false,
      urlVideoRaw: "",

      fondoPYT: null,
      tituloUno: "",
      tituloDos: "",
      tituloTres: "",

      isMobile: window.innerWidth < 768,

      youngTalentRaw: [],
      youngTalentSlides: [], 

      language: null,
    };
  },
  computed: {
    urlVideoEmbed() {
      return this.makeEmbedUrl(this.urlVideoRaw);
    },
    dialogWidth() {
      return this.isMobile ? '100%' : '900';
    },
    modalVideoStyle() {
      if (this.isMobile) {
        return {
          width: 'calc(100vw - 32px)',
          height: 'calc(100vh - 120px)',
          maxWidth: '100vw',
          maxHeight: '100vh',
        };
      } else {
        return {
          width: '800px',
          height: '600px',
          maxWidth: '90vw',
          maxHeight: '80vh',
        };
      }
    }
  },
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.onDialogClose();
      } else {
        document.body.style.overflow = 'hidden';
      }
    }
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
    // escuchamos ESC globalmente
    window.addEventListener("keydown", this.handleKeydown);
    this.handleResize();

    // AOS animaciones
    AOS.init({ duration: 1000 });

    // cargar data
    this.getProgramaYTSeccionUnoPYT(); // banner
    this.getProgramaYTSeccionDosPYT(); // carrusel
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("keydown", this.handleKeydown);
  },
  methods: {
    /* =========================
       RESPONSIVE
    ========================== */
    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },

    // manejar ESC global
    handleKeydown(e) {
      if (e.key === "Escape" || e.key === "Esc") {
        if (this.dialog) {
          this.closeModal();
        }
      }
    },

    /* =========================
       SECCIÓN 1 (banner arriba)
    ========================== */
    async getProgramaYTSeccionUnoPYT() {
      try {
        const { data } = await axiosIns.get(
          "/talentoagv/getProgramaYTSeccionUnoPYT/"
        );
        if (data?.is_error)
          throw new Error(data?.message || "Error en el servidor");

        const result = data.result || [];

        // Fondo dinámico desde el primer registro con imagen válida
        const fondo = result.find((r) => r.s3_url);
        this.fondoPYT = fondo ? fondo.s3_url : this.fondoPYT;

        // Palabras del título
        const palabras = result
          .map((r) => (r.palabra || "").trim())
          .filter(Boolean);

        // Ejemplo:
        // "Conoce a nuestros"
        // "Young Talent!"
        // "" (o lo que venga)
        this.tituloUno = palabras[0] || "";
        this.tituloDos = palabras[1] || "";
        this.tituloTres = palabras[2] || "";
      } catch (error) {
        console.error("Error al obtener sección 1 PYT:", error);
      }
    },

    /* =========================
       SECCIÓN 2 (carrusel talento)
    ========================== */

    async getProgramaYTSeccionDosPYT() {
      try {
        const { data } = await axiosIns.get(
          "/talentoagv/getProgramaYTSeccionDosPYT/"
        );
        if (data?.is_error)
          throw new Error(data?.message || "Error en el servidor");

        const rows = Array.isArray(data?.result) ? data.result : [];

        // normalizamos
        const list = rows.map((r) => {
          const cleanEdad = (r.edad || "")
            .toString()
            .replace(/\s*años?$/i, "")
            .trim();

          return {
            id: r.id_secciondos_pyt,
            name: (r.nombre || "").toString(),
            age: cleanEdad, // solo número
            img: r.image_s3_url || "",
            video_url: r.video_url || "",
          };
        });

        this.youngTalentRaw = list;
        // Desktop: chunked
        this.youngTalentSlides = this.chunkArray(list, 3);
      } catch (error) {
        console.error("Error al obtener sección 2 PYT:", error);
      }
    },

    // separa en slides de 3
    chunkArray(list, size = 3) {
      const chunks = [];
      for (let i = 0; i < list.length; i += size) {
        chunks.push({
          items: list.slice(i, i + size),
        });
      }
      return chunks;
    },

    /* =========================
       VIDEO MODAL
    ========================== */
    openVideoTalent(item) {
      this.urlVideoRaw = item.video_url || "";
      this.dialog = true;
    },

    makeEmbedUrl(url) {
      if (!url) return "";

      // Vimeo player.vimeo.com/video/ID (ya embed)
      if (/player\.vimeo\.com\/video\//i.test(url)) {
        return url;
      }

      // Vimeo normal vimeo.com/12345 -> player.vimeo.com/video/12345
      const vimeoMatch = url.match(/vimeo\.com\/(\d+)/i);
      if (vimeoMatch) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
      }

      // YouTube largo https://www.youtube.com/watch?v=ABC123
      const ytFull = url.match(/[?&]v=([^&]+)/i);
      if (ytFull) {
        return `https://www.youtube.com/embed/${ytFull[1]}`;
      }

      // YouTube corto https://youtu.be/ABC123
      const ytShort = url.match(/youtu\.be\/([^?]+)/i);
      if (ytShort) {
        return `https://www.youtube.com/embed/${ytShort[1]}`;
      }

      // mp4 directo u otro hosting -> dejamos tal cual
      return url;
    },

    // Cerrar modal desde el botón o ESC o overlay => cierra dialog (watch limpiará)
    closeModal() {
      // cerramos el dialog (watch se encargará de onDialogClose)
      this.dialog = false;
    },

    // Al cerrar el modal: limpiar y reactivar scrolling
    onDialogClose() {
      // Limpiar url (opcional para liberar src)
      this.urlVideoRaw = "";

      // reactivar scrolling del body si lo desactivamos
      document.body.style.overflow = '';
    },

    /* =========================
       LÓGICA EXTERNA QUE YA TENÍAS
    ========================== */
    getMainPageData() {
      // si Header_AS dispara este evento, aquí haces lo que necesites
    },
  },
};
</script>

<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/young_talent_AS.css"></style>

<style scoped>
/* color celeste dentro del título del banner */
.banner-title-culture {
  color: #00b8f1;
}

/* ===== HEADER AZUL (la franja con “Conoce a nuestros Young Talent”) */
.section-header-our-young-talent {
  background-color: #000c2a;
}
.section-header-our-young-talent-header-title {
  font-weight: 700;
  font-size: clamp(1.4rem, 0.4vw + 1rem, 2rem);
  line-height: 1.3;
  color: #fff;
  margin: 0;
  display: flex;
  gap: 0.75rem;
}
.arrow-icon {
  width: 32px;
  height: auto;
  filter: brightness(0) invert(1);
}
/* color celeste dentro del título del banner */
.banner-title-culture {
  color: #00b8f1;
}

/* ===== HEADER AZUL (la franja con “Conoce a nuestros Young Talent”) */
.section-header-our-young-talent {
  background-color: #000c2a;
}
.section-header-our-young-talent-header-title {
  font-weight: 700;
  font-size: clamp(1.4rem, 0.4vw + 1rem, 2rem);
  line-height: 1.3;
  color: #fff;
  margin: 0;
  display: flex;
  gap: 0.75rem;
}
.arrow-icon {
  width: 32px;
  height: auto;
  filter: brightness(0) invert(1);
}

/* ===== CONTENEDOR CARRUSEL */
.section-content-our-young-talent {
  background-color: #ffffff;
}

/* carrusel interno */
.container-carousel-our-young-talent {
  /* opcional: limita un poco para que no pegue a los costados extremos */
  max-width: 1400px;
  margin-left: auto;
  margin-right: auto;
}

/* Wrapper para dar espaciado entre slides (simula gap) */
.slide-content-wrapper {
  padding: 0 1rem; /* Espacio horizontal entre items */
  width: 100%;
}

/* grilla interna de cada slide (3 cards) */
.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
}

/* tarjeta */
.grid-item {
  position: relative;
  border-radius: 12px;
  background-color: #000;
  min-height: 240px;
  max-height: 300px;
  overflow: hidden;
  display: block;
  width: 100%; /* Ocupa el ancho disponible del wrapper */
}

/* imagen full cover */
.carousel-card-img {
  position: relative;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}


.grid-item-caption {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;

  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1rem;

  padding: 16px 20px;
  z-index: 2;
  color: #fff;
  font-family: inherit;
  line-height: 1.4;
}

.grid-item-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

/* nombre */
.grid-item-name {
  font-size: 1.125rem; /* ~18px */
  font-weight: 700;
  color: #fff;
  margin: 0 0 0.25rem 0;
  word-wrap: break-word;
}

/* edad */
.grid-item-age {
  font-size: 1rem;
  font-weight: 400;
  color: #fff;
  opacity: 0.9;
  margin: 0;
}

/* botón play circular al lado derecho */
.grid-item-play {
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 999px;
  border: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: background 0.15s ease;
}
.grid-item-play:hover {
  background: rgba(0, 0, 0, 0.6);
}

/* dots del carrusel */
.custom-dots {
  margin-top: 1.5rem;
  display: flex;
  justify-content: center;
}

/* Ajustes responsive para la altura de la card */
@media (max-width: 767px) {
  .grid-item {
    min-height: 320px;
    max-height: 360px;
  }
}

@media (min-width: 768px) and (max-width: 991px) {
  .grid-container {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem !important;
  }
}

@media (min-width: 992px) {
  .grid-container {
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
  }
}

/* Modal styles */
.modal-transparent {
  background: transparent;
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

/* BOTÓN CERRAR - estilo blanco con X negra */
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  background: white;
  color: black;
  border: none;
  border-radius: 50%;
  font-size: 15px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 9999;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: transform 0.2s ease;
}
.close-btn:active {
  transform: scale(0.9);
}

/* When mobile, make the modal card full screen (we also control dialog width in JS) */
.modal-fullscreen {
  width: 100% !important;
  height: 100% !important;
  margin: 0;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Wrapper around video for proper centering & padding on mobile */
.modal-video-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

/* Modal video: use object-fit: contain to show all frame without crop */
.modal-video {
  display: block;
  border-radius: 12px;
  object-fit: contain;
  background: #040404;
  max-width: 100%;
  max-height: 100%;
  /* For desktop we use the inline styles computed (800x600). For mobile the computed styles use vw/vh */
}

/* Mobile specific adjustments */
@media (max-width: 576px) {
  /* Mobile specific: reduce modal padding so the video uses more height */
  .modal-video-wrapper {
    padding: 8px;
  }

  .modal-video {
    border-radius: 8px;
  }

  /* Ajusta la posición del botón cerrar en mobile (un poco más adentro) */
  .close-btn {
    top: 10px;
    right: 10px;
    width: 40px;
    height: 40px;
    font-size: 17px;
  }
}
</style>
